/* eslint-disable */
import { useState, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { getAuth, signOut } from "firebase/auth";
import {
  User,
  ChevronDown,
  Crown,
  Trash2,
  Settings,
  LogOut,
} from "lucide-react";
import { logoutUser } from "../../../redux/user/user";
import freeCountries from "../../../utils/freeCountries.json";
import { updateDoc, doc } from "firebase/firestore";
import { db } from "../../../firebase";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const AvatarMenu = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "ar";
  const auth = getAuth();
  const navigate = useNavigate();
  const digitalStore = useSelector((state) => state.digitalStoreReducer);

  const account = useSelector((state) => state.AccountReducer);
  const worker = useSelector((state) => state.workerReducer);
  const products = useSelector((state) => state.ProductsReducer);
  const dispatch = useDispatch();
  const [state, setState] = useState(false);
  const profileRef = useRef();
  const isFreeCountry = freeCountries.includes(account?.country);
  const [updating, setUpdating] = useState(false);

  const [productMode, setProductMode] = useState(
    account?.productMode !== undefined && account?.productMode !== null
      ? account?.productMode
      : "classic"
  );

  const handleSLogout = () => {
    signOut(auth)
      .then(() => {
        dispatch(logoutUser(""));
        localStorage.setItem("token", "");
      })
      .catch((error) => {
        console.error("Error signing out:", error);
      });
  };

  // const getTimeRemaining = (rowData) => {
  //   const totalSeconds = (new Date(rowData.seconds * 1000) - new Date()) / 1000;
  //   const years = Math.floor(totalSeconds / (60 * 60 * 24 * 365));
  //   const months = Math.floor(
  //     (totalSeconds % (60 * 60 * 24 * 365)) / (60 * 60 * 24 * 30)
  //   );
  //   const days = Math.floor(
  //     (totalSeconds % (60 * 60 * 24 * 30)) / (60 * 60 * 24)
  //   );
  //   return { totalSeconds, years, months, days };
  // };

  // const dateBodyTemplate = (rowData) => {
  //   const remainingTime = getTimeRemaining(rowData);
  //   if (remainingTime.totalSeconds <= 0) return t("navbar.avatarMenu.lifetime");
  //   const { years, months, days } = remainingTime;
  //   let remainingString = "";
  //   if (years > 0)
  //     remainingString += `${years} ${t("navbar.avatarMenu.years")} ,`;
  //   if (months > 0)
  //     remainingString += `${months} ${t("navbar.avatarMenu.months")} ,`;
  //   if (days > 0) remainingString += `${days} ${t("navbar.avatarMenu.days")} `;
  //   return remainingString.trim();
  // };

  const handleClick = () => {
    window.open(`${account?.store}`, "_blank", "noopener,noreferrer");
  };

  useEffect(() => {
    if (account?.productMode && account?.productMode !== productMode) {
      setProductMode(account?.productMode);
    }
  }, [account?.productMode]);

  const handleModeChange = async (mode) => {
    if (mode === productMode) return;

    setProductMode(mode);
    setUpdating(true);
    try {
      const accountRef = doc(db, "account", account?.id);
      await updateDoc(accountRef, { productMode: mode });
      navigate("/dashboard");
    } catch (error) {
      console.error("Erreur de mise à jour du mode produit :", error);
    } finally {
      setUpdating(false);
    }
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setState(false);
      }
    };
    window.addEventListener("click", handleOutsideClick);
    return () => window.removeEventListener("click", handleOutsideClick);
  }, [state]);

  const planKeyMap = {
    الأساسية: "basic",
    الاساسية: "basic",
    basic: "basic",

    المتطورة: "advanced",
    advanced: "advanced",

    الأسطورية: "legendary",
    الاسطورية: "legendary",
    legendary: "legendary",
  };
  const planKey = planKeyMap[account?.subscription?.plan ?? ""];

  return (
    <div className="relative" ref={profileRef} onClick={() => setState(!state)}>
      {/* Avatar Button */}
      <button className="flex items-center gap-2 focus:outline-none">
        {/* Mobile User Icon */}
        <div className="md:hidden flex items-center justify-center w-10 h-10 rounded-lg bg-[#faf1ff] dark:bg-[#2a1a38] text-[#9e68ba]">
          <User size={20} className="text-[#9e68ba] dark:text-[#edd9f7]" />
        </div>

        {/* Desktop Avatar */}
        <div className="hidden md:flex items-center">
          <div className="mx-2 rounded-lg overflow-hidden shadow-sm w-10 h-10 bg-[#faf1ff] dark:bg-[#2a1a38] bg-[#fcf6ff] flex items-center justify-center overflow-hidden transition-colors">
            <User size={20} className="text-[#9e68ba] dark:text-[#edd9f7]" />
          </div>

          {account && (
            <div className="flex items-center space-x-1 mr-2 text-sm font-medium text-[#9e68ba] transition-colors">
              <span>{worker?.name}</span>
              <ChevronDown size={16} className="text-[#9e68ba]" />
            </div>
          )}
        </div>
      </button>

      {/* Dropdown Menu */}
      <div
        className={`absolute ${
          isRTL ? "left-0" : "right-0"
        } top-12 w-72 bg-white dark:!bg-[#181919] rounded-xl shadow-lg border border-[#fbf4ff] dark:!border-[#3c3a3d] overflow-hidden transition-all duration-200 z-50 ${
          state
            ? "opacity-100 translate-y-0"
            : "opacity-0 translate-y-2 pointer-events-none"
        }`}
      >
        {/* User Info Section */}
        <div className="p-4 border-b border-purple-50 dark:border-[#3c3a3d]">
          <div className="mb-3">
            {worker && (
              <p className="text-gray-800 dark:!text-white font-medium">
                {worker?.name}
              </p>
            )}
            {worker && (
              <p className="text-gray-500 dark:!text-white text-sm">
                {worker?.email}
              </p>
            )}
          </div>

          <div className="flex items-center gap-2">
            {account && (
              <span className="px-3 py-1 bg-green-50 text-green-700 text-xs font-medium rounded-full">
                {isFreeCountry
                  ? t("navbar.avatarMenu.free")
                  : t("ui.notAvailable")}
                  {/* ? t(`subscription.plans.${planKey}`)
                  : account?.subscription?.plan ?? "N/A"} */}
              </span>
            )}
            <button
              onClick={handleClick}
              className="px-3 py-1 bg-[#fcf6ff] text-[#9e68ba] text-xs font-medium rounded-full hover:bg-[#faf1ff] transition-colors"
            >
              {t("navbar.avatarMenu.viewStore")}
            </button>
          </div>
        </div>

        {/* {digitalStore.isActiveDigitalProducts && (
          <div className="p-4 border-b border-purple-50 dark:border-[#3c3a3d]">
            <div className="mb-2">
              <p className="text-sm font-medium text-gray-700 mb-3 dark:text-gray-200">
                {t("navbar.avatarMenu.title")}
              </p>
            </div>
            <div className="flex gap-2 bg-gray-50 dark:bg-[#181819] p-1 rounded-lg">
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleModeChange("digital");
                }}
                disabled={updating}
                className={`flex-1 px-3 py-2 text-xs font-medium rounded-md transition-all duration-200 ${
                  productMode === "digital"
                    ? "bg-[#9e68ba] text-white  shadow-sm"
                    : "text-gray-600  hover:shadow-sm dark:text-gray-300 hover:bg-white"
                }`}
              >
                {t("navbar.avatarMenu.digital")}
              </button>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleModeChange("classic");
                }}
                className={`flex-1 px-3 py-2 text-xs font-medium rounded-md transition-all duration-200 ${
                  productMode === "classic"
                    ? "bg-[#9e68ba] text-white shadow-sm"
                    : "text-gray-600 hover:bg-white hover:shadow-sm dark:text-gray-300"
                }`}
              >
                {t("navbar.avatarMenu.classic")}
              </button>
            </div>
          </div>
        )} */}

        {/* Subscription Info */}
        {/* <div className="px-4 py-3 bg-[#fcf6ff] dark:!bg-[#2a2b2b]">
          {account && (
            <p className="text-sm">
              <span className="text-[#9e68ba] dark:text-[#edd9f7] font-medium">
                {t("navbar.avatarMenu.expirationDate")}{" "}
              </span>
              <span className="text-gray-700 dark:text-white">
                {dateBodyTemplate(account?.subscription?.endDate)}
              </span>
            </p>
          )}
        </div> */}

        {/* Menu Items */}
        <div className="py-2">
          {/* <Link
            to="/subscription"
            className="flex items-center gap-3 px-4 py-3 text-gray-700 hover:bg-[#fcf6ff] dark:hover:bg-purple-300 transition-colors"
          >
            <Crown size={16} className="text-[#9e68ba] dark:text-[#edd9f7]" />
            <span className="text-sm font-medium dark:text-white">
              {t("navbar.avatarMenu.manageSubscription")}
            </span>
          </Link>

          <button
            onClick={() => apicache(account, products)}
            className="flex items-center gap-3 px-4 py-2 w-full text-left text-gray-700 hover:bg-[#fcf6ff] dark:hover:bg-purple-300 transition-colors"
          >
            <Trash2 size={16} className="text-[#9e68ba] dark:text-[#edd9f7]" />
            <span className="text-sm font-medium dark:text-white">
              {t("navbar.avatarMenu.clearCache")}
            </span>
          </button> */}

          <Link
            to="/team/settings/account"
            className="flex items-center gap-3 px-4 py-3 text-gray-700 hover:bg-[#fcf6ff] dark:hover:bg-purple-300 transition-colors"
          >
            <Settings
              size={16}
              className="text-[#9e68ba] dark:text-[#edd9f7]"
            />
            <span className="text-sm font-medium dark:text-white">
              {t("navbar.avatarMenu.accountSettings")}
            </span>
          </Link>
        </div>

        {/* Logout Button */}
        <div className="border-t border-purple-50 dark:border-[#3c3a3d]">
          <button
            onClick={handleSLogout}
            className="flex items-center gap-3 px-4 py-3 w-full text-left text-red-600 hover:bg-red-50 dark:hover:bg-red-400 transition-colors"
          >
            <LogOut size={16} className="text-red-500" />
            <span className="text-sm font-medium">
              {t("navbar.avatarMenu.logout")}
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default AvatarMenu;
